import { gql } from "@apollo/client";

export const GET_IMPRIMIR_MINUTA_DOCUMENTOS = gql`
    query GetDocumentosMinuta($idMinuta: Int!) {
        documentosMinuta(idMinuta: $idMinuta) {
            idDocMinuta,
            descripcion
        }
    }
`;

export const adaptImprimirMinutasDocumento = (documento) => {
  return {
    idDocMinuta: documento?.idDocMinuta,
    descripcion: documento?.descripcion
  };
};

export const adaptImprimirMinutasDocumentosArray = (documentos) => {
  return structuredClone(documentos)?.
  map((documento) => adaptImprimirMinutasDocumento(documento));
};